import { useContext } from "react";
import * as PropTypes from "prop-types";
import { buyNowContext } from "../BuyNow";
import { calcPromoDiscount } from "../../utils/pricingHelper";

/**
 * Return a string representing the discount amount of the promo code.
 */
const PromoAmount = ({ hideDecimalIfWhole }) => {
  const { lineItems, promoCode, shippingStageState } = useContext(buyNowContext);
  const { country, shippingMethod } = shippingStageState;

  let result = calcPromoDiscount(lineItems, promoCode, shippingMethod, country)

  if (hideDecimalIfWhole && result % 1 === 0)
    return String(result);
  else
    return result.toFixed(2);
};

PromoAmount.propTypes = {
  hideDecimalIfWhole: PropTypes.bool
};

PromoAmount.defaultProps = {
  hideDecimalIfWhole: false
};

export default PromoAmount;
